<template>
	<div class="p4">
		<!-- For Individuals -->
		<div v-if="entityType === 'individual'">
			<core-form-input
				componentName="j-base-radios"
				id="salutation"
				name="salutation"
				label="Salutation"
				:options="options.salutationTypes"
				v-model="form.individual.salutation"
			/>
			<core-form-input
				componentName="j-base-radios"
				id="gender"
				name="gender"
				label="Gender"
				:options="options.genderTypes"
				v-model="form.individual.gender"
				class="mt6"
			/>
			<div class="flex xs-12 mt6">
				<div class="flex xs-6">
					<core-form-input
						componentName="j-base-input-text"
						id="englishFirstName"
						name="englishFirstName"
						label="First Name"
						subheadline="English"
						v-model="form.individual.englishFirstName"
						class="pr2"
					/>
				</div>
				<div class="flex xs-6">
					<core-form-input
						componentName="j-base-input-text"
						id="englishLastName"
						name="englishLastName"
						label="Last Name"
						subheadline="English"
						v-model="form.individual.englishLastName"
						class="pl2"
					/>
				</div>
			</div>

			<div class="flex xs-12 mt6">
				<div class="flex xs-6">
					<core-form-input
						componentName="j-base-input-text"
						id="chineseFirstName"
						name="chineseFirstName"
						label="First Name"
						subheadline="Chinese"
						v-model="form.individual.chineseFirstName"
						class="pr2"
					/>
				</div>
				<div class="flex xs-6">
					<core-form-input
						componentName="j-base-input-text"
						id="chineseLastName"
						name="chineseLastName"
						label="Last Name"
						subheadline="Chinese"
						v-model="form.individual.chineseLastName"
						class="pl2"
					/>
				</div>
			</div>

			<core-form-input
				componentName="j-base-input-text"
				id="email"
				name="email"
				label="Email"
				v-model="form.individual.email"
				class="mt6"
			/>
			<core-form-input
				componentName="j-base-date-picker-simple"
				id="dateOfBirth"
				name="dateOfBirth"
				label="Date Of Birth"
				subheadline="DD/MM/YYYY"
				v-model="form.individual.dateOfBirth"
				class="mt6"
			/>
			<core-form-input
				componentName="j-base-input-text"
				id="occupation"
				name="occupation"
				label="Occupation"
				v-model="form.individual.occupation"
				class="mt6"
			/>
			<!-- <core-form-input
				componentName="j-base-radios"
				id="maritalStatus"
				name="maritalStatus"
				label="Marital Status"
				:options="options.maritalStatusTypes"
				v-model="form.individual.maritalStatus"
				class="mt6"
			/>
			<core-form-input
				componentName="j-base-select"
				id="countryOfResidency"
				name="countryOfResidency"
				label="Country Of Residency"
				:options="options.countries"
				v-model="form.individual.countryOfResidency"
				class="mt6"
			/>
			<core-form-input
				componentName="j-base-input-text"
				id="preferredCommunicationChannel"
				name="preferredCommunicationChannel"
				label="Preferred Communication Channel"
				v-model="form.individual.preferredCommunicationChannel"
				class="mt6"
			/>
			<core-form-input
				componentName="j-base-input-text"
				id="preferredLanguage"
				name="preferredLanguage"
				label="Preferred Language"
				v-model="form.individual.preferredLanguage"
				class="mt6"
			/> -->
		</div>

		<div v-if="entityType === 'company'">
			<core-form-input
				componentName="j-base-input-text"
				id="name"
				name="name"
				label="Name"
				v-model="form.company.nameFormat"
			/>
			<core-form-input
				componentName="j-base-input-text"
				id="natureOfBusiness"
				name="natureOfBusiness"
				label="Nature Of Business"
				v-model="form.company.natureOfBusiness"
				class="mt6"
			/>
			<core-form-input
				componentName="j-base-input-text"
				id="registrationNumber"
				name="registrationNumber"
				label="Registration Number"
				v-model="form.company.registrationNumber"
				class="mt6"
			/>
		</div>

		<!-- Object -->
		<div v-if="entityType === 'object'">
			<core-form-input
				componentName="j-base-input-text"
				id="name"
				name="name"
				label="Name"
				v-model="form.object.nameFormat"
			/>
		</div>

		<!-- Buttons -->
		<div class="flex mt6 xs-between">
			<j-button :isLoading="isLoading" type="primary" @click="createEntity">
				{{ $t("create") }}
			</j-button>
			<j-button
				:isDisabled="isLoading"
				type="bordered"
				@click="$emit('cancel')"
			>
				{{ $t("cancel") }}
			</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput.vue"
import JButton from "@/components/JButton"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import {
	countries,
	salutationTypes,
	genderTypes,
	maritalStatusTypes
} from "@/forms/enums.js"

export default {
	components: { CoreFormInput, JButton },
	props: {
		entityType: {
			validator(val) {
				return [
					"individual",
					"company",
					"object",
					"participant",
					"organization"
				].includes(val)
			},
			default: "individual"
		}
	},

	data() {
		return {
			isLoading: false,

			options: {
				countries: countries,
				salutationTypes: salutationTypes,
				genderTypes: genderTypes,
				maritalStatusTypes: maritalStatusTypes
			},

			form: {
				//individual
				individual: {
					salutation: null,
					gender: null,
					englishFirstName: null,
					englishLastName: null,
					chineseFirstName: null,
					chineseLastName: null,
					email: null,
					dateOfBirth: null,
					occupation: null,
					maritalStatus: null,
					countryOfResidency: null,
					preferredCommunicationChannel: null,
					preferredLanguage: null,
					type: "CUSTOMER"
				},

				//company
				company: {
					nameFormat: null,
					natureOfBusiness: null,
					registrationNumber: null,
					type: "CUSTOMER"
				},

				// object
				object: {
					nameFormat: null
				}
			}
		}
	},

	methods: {
		async createEntity() {
			// Based on this.entityType, call proper API
			if (this.entityType === "individual") this.createIndividual()
			if (this.entityType === "company") this.createCompany()
			if (this.entityType === "object") this.createObject()
		},

		async createIndividual() {
			const query = gql`
				mutation createIndividual($input: createIndividualInput!) {
					createIndividual(createIndividualInput: $input) {
						status
						errors
						createdStatus {
							id
						}
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					input: { ...this.form.individual }
				}
			})
			this.isLoading = false

			// Errors
			if (res?.data?.createIndividual?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.createIndividual?.errors?.[0] || this.$t("errors.general")
				)
				return
			}

			// Success - emit event to parent with payload of object
			const {
				englishFirstName,
				englishLastName,
				chineseFirstName,
				chineseLastName
			} = this.form.individual

			this.$emit("entity:created", {
				id: res?.data?.createIndividual?.createdStatus?.id,
				name: englishFirstName
					? `${englishFirstName} ${englishLastName}`
					: `${chineseFirstName} ${chineseLastName}` // NOTE: trying to emulate `name` as our API doesn't return created type
			})
		},

		async createCompany() {
			const query = gql`
				mutation createCompany($input: createCompanyInput!) {
					createCompany(createCompanyInput: $input) {
						status
						createdStatus {
							id
						}
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					input: { ...this.form.company }
				}
			})
			this.isLoading = false

			// Errors
			if (res?.data?.createCompany?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.createCompany?.errors?.[0] || this.$t("errors.general")
				)
				return
			}

			// Success - emit event to parent with payload of object
			this.$emit("entity:created", {
				id: res?.data?.createCompany?.createdStatus?.id,
				name: this.form.company.nameFormat
			})
		},

		async createObject() {
			const query = gql`
				mutation createObject($input: createObjectInput!) {
					createObject(createObjectInput: $input) {
						createdStatus {
							id
						}
						status
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: {
					input: { ...this.form.object }
				}
			})
			this.isLoading = false

			// Errors
			if (res?.data?.createObject?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.createObject?.errors?.[0] || this.$t("errors.general")
				)
				return
			}

			// Success - emit event to parent with payload of object
			this.$emit("entity:created", {
				id: res?.data?.createObject?.createdStatus?.id,
				name: this.form.object.nameFormat
			})
		}
	}
}
</script>
